module.exports = __webpack_public_path__ + "static/media/settings.393692f5.svg";